var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VMC - Ventilation M\xE9canique Contr\xF4l\xE9e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VMC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,40 L40,15 L70,40 L70,70 L10,70 Z",
    fill: "#E8F0FE",
    stroke: "#333333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,40 L40,10 L75,40",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45,
    width: 15,
    height: 15,
    fill: "#A5D8FF",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 45,
    x2: 32.5,
    y2: 60,
    stroke: "#333333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 52.5,
    x2: 40,
    y2: 52.5,
    stroke: "#333333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 12,
    height: 20,
    fill: "#D2A979",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 60,
    r: 1,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 25,
    height: 12,
    rx: 2,
    fill: "#DADADA",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 19,
    height: 6,
    rx: 1,
    fill: "#888888",
    stroke: "#333333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C18,27 22,31 25,28",
    stroke: "#4DA1FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,33 C18,30 22,34 25,31",
    stroke: "#4DA1FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 31,
    r: 5,
    fill: "#FFFFFF",
    stroke: "#333333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,28 L50,34",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,31 L53,31",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,29 L52,33",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,33 L52,29",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmc);
export default __webpack_public_path__ + "static/media/vmc.b11d7cc11aeeada666f2373caf87e902.svg";
export { ForwardRef as ReactComponent };